
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Lavorazione, GruppoLavorazioniPerConsegna, Utente, FinderGruppoLavorazioniPerConsegna, TextValueItem } from '@/models';
import { store, StoreActions } from '@/store';
import { Loading } from '@/components';
import dayjs from 'dayjs';
import { LoadingTemplateType } from './enums/LoadingTemplateType';
import { MultiSelectDescriptor } from '@/models/finders/MultiSelectDescriptor';

@Component({
  components: {
    Loading,
    FilterPopup: () => import('@/components/shared/FilterPopup.vue'),
    ProgressBar: () => import('@/components/shared/ProgressBar.vue')
  }
})
export default class GruppoLavorazionePerConsegnaTabella extends Vue {
    get page(): number { return store.state.uiGruppoLavorazioniPerConsegna.pagina; }
    set page(value: number) { this.caricaGruppoLavorazioniPerConsegna(value); }

    get itemsPerPage(): number {return store.state.uiGruppoLavorazioniPerConsegna.dimensionePaginaListe }
    get pageCount(): number { return store.state.uiGruppoLavorazioniPerConsegna.totPagine; }
    get numTotOrdini(): number { return store.state.uiGruppoLavorazioniPerConsegna.totGruppi; }
    get user() { return store.state.currentUsr; }
    get userIsAdmin() {
        return (
        this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
        undefined
        );
    }
    get loading () {
        return store.state.uiGruppoLavorazioniPerConsegna.loadingGruppoLavorazioniPerConsegna;
    }

    get lavorazione(): Lavorazione | undefined {
        return store.state.lavorazioneCorrente;
    }

    get loadTemplateCorrente() : LoadingTemplateType {
        return LoadingTemplateType.DataTable;
    }

    filters: any = {}
    
    get dataSourceStagioni(): TextValueItem[] {
        return store.state.uiGruppoLavorazioniPerConsegnaDataSource.dataSourceStagioni;
    }
    get dataSourceConsegne(): TextValueItem[] {
        return store.state.uiGruppoLavorazioniPerConsegnaDataSource.dataSourceConsegne;
    }

    get headers(): any[] {
        return [
            {
                text: "Progresso",
                value: "Progresso",
                align: 'center',
                sortable: false,
            },
            {
                text: "Consegna",
                value: "Consegna",
                align: 'center',
                sortable: false,
                filter: {
                    type: 'multiselect',
                    field: 'consegna',
                    dataSource: this.dataSourceConsegne
                }
            },
            {
                text: "Stagione",
                value: "Stagione",
                align: 'center',
                sortable: false,
                filter: {
                    type: 'multiselect',
                    field: 'stagione',
                    dataSource: this.dataSourceStagioni
                }
            },
            {
                text: "Capi lanciati",
                value: "Capi lanciati",
                align: 'center',
                sortable: false,
            },
            {
                text: "Capi rientrati",
                value: "Capi rientrati",
                align: 'center',
                sortable: false,
            },
            {
                text: "Carico Capi",
                value: "Carico Capi",
                align: 'center',
                sortable: false,
            }
        ];
    }
    get fornitore(): Utente | undefined {
        return store.state.fornitore;
    }
    private idFornitore: string = '';
    async created(){
        if (this.userIsAdmin) {
            if(this.fornitore){
                this.idFornitore = this.fornitore.id;
                await this.caricaDataSources();
                this.caricaGruppoLavorazioniPerConsegna(1);
            }
        } else {
            this.idFornitore = this.user.idFornitore;
                await this.caricaDataSources();
            this.caricaGruppoLavorazioniPerConsegna(1);
        }
    }

    private caricaGruppoLavorazioniPerConsegna(pagina: number): void {
        let parametri: FinderGruppoLavorazioniPerConsegna = {
            numeroPagina: pagina,
            idFornitore: this.idFornitore ?? "",
            dimensionePagina: store.state.uiGruppoLavorazioniPerConsegna.dimensionePaginaListe,
            consegna: "", //TODO valorizzare da filtro, se necessario
        }

        if( this.filters["stagione"] && this.filters["stagione"].filter &&  this.filters["stagione"].filter.length){
            parametri.filtroStagione = new MultiSelectDescriptor(this.filters["stagione"].operator, this.filters["stagione"].filter);
        }

        if( this.filters["consegna"] && this.filters["consegna"].filter &&  this.filters["consegna"].filter.length){
            parametri.filtroConsegna = new MultiSelectDescriptor(this.filters["consegna"].operator, this.filters["consegna"].filter);
        }

        store.dispatch(StoreActions.GetGruppoLavorazioniPerConsegna, parametri);
    }

    private async caricaDataSources() {
        let parametri: FinderGruppoLavorazioniPerConsegna = {
            numeroPagina: 0,
            idFornitore: this.idFornitore ?? "",
            dimensionePagina: 0,
            consegna: "", //TODO valorizzare da filtro, se necessario,
        }
        await store.dispatch(StoreActions.GetGruppoLavorazioniPerConsegnaDataSources, parametri)
    }

    get items(): GruppoLavorazioniPerConsegna[] {
        return store.state.uiGruppoLavorazioniPerConsegna.gruppoLavorazioniPerConsegna;
    }

    onSetfilter(filterItem : any) {
        this.filters[filterItem.field] = {operator: filterItem.operator, filter: filterItem.filter};
        this.caricaGruppoLavorazioniPerConsegna(1);
    }

    onRemoveFilter(filterItem : any) {
        delete this.filters[filterItem.field];
        this.caricaGruppoLavorazioniPerConsegna(1);
    }

    @Watch("$store.state.fornitore")
    onCambioFiltri() {
        this.idFornitore = store.state.fornitore?.id ?? "";
        this.caricaGruppoLavorazioniPerConsegna(store.state.uiGruppoLavorazioniPerConsegna.pagina);
    }
}

